import { render, staticRenderFns } from "./payConfigure.vue?vue&type=template&id=8aa029ca&scoped=true&"
import script from "./payConfigure.vue?vue&type=script&lang=js&"
export * from "./payConfigure.vue?vue&type=script&lang=js&"
import style0 from "./payConfigure.vue?vue&type=style&index=0&id=8aa029ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa029ca",
  null
  
)

export default component.exports